/**
 * refreshOverrides — orquestador de Modo Edición (guardado directo).
 * A propósito es el único módulo que conoce `overridesRuntime.ts`,
 * `santa-coloma.ts` y `osm-group-mapping-resolved.ts` a la vez — ninguno
 * de los tres lo importa de vuelta, así que no forma parte de ningún
 * ciclo de módulos (ver la nota en `overridesRuntime.ts`).
 */
import { setOverridesData, type OverridesPayload } from './overridesRuntime';
import { recomputeSantaColomaData } from './santa-coloma';
import { recomputeOsmGroupMapping } from './osm-group-mapping-resolved';
import { useOverridesVersion } from '../store/overridesVersion';

export function applyRuntimeOverrides(payload: OverridesPayload): void {
  setOverridesData(payload);
  recomputeOsmGroupMapping();
  recomputeSantaColomaData();
  useOverridesVersion.getState().bump();
}

export async function fetchAndApplyOverrides(): Promise<void> {
  const res = await fetch('/api/overrides', { credentials: 'include' });
  if (!res.ok) throw new Error(`GET /api/overrides → ${res.status}`);
  applyRuntimeOverrides(await res.json());
}
